/**
 * Notify splash that the first screen is ready to reveal.
 * Re-asserts if the launch gate is reset while this screen is still ready.
 */
import { useEffect } from 'react';
import { setSplashPageReady, subscribeSplashPageReady } from './splashGate';

export function useReportSplashPageReady(ready: boolean): void {
  useEffect(() => {
    if (!ready) {
      return;
    }
    setSplashPageReady(true);
    return subscribeSplashPageReady(is_ready => {
      if (!is_ready) {
        setSplashPageReady(true);
      }
    });
  }, [ready]);
}
